import Grid from "@mui/material/Grid";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import Singleselect from "./Singleselect";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import FormControl from "@mui/material/FormControl";
import React, { useEffect, useState } from "react";
import PayableSelecte from "../PayableSelecte";

const Payable = (props) => {
  const [processpayable, setprocesspayable] = useState(false);
  useEffect(async () => {
    console.log(props.data, "payable");
    if (props.payable == "yes") {
      setprocesspayable(true);
    }
    // alert(props.payable)
  }, []);
  return (
    <>
      <Grid item md={12}>
        <MDBox>
          <FormControl>
            <FormLabel id="demo-row-radio-buttons-group-label">
              <MDTypography
                variant="h6"
                sx={{ fontSize: "16px", fontWeight: "400" }}
                display="block"
                gutterBottom
              >
                Is the {props.type} payable?
              </MDTypography>
            </FormLabel>
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="payable"
              sx={{ marginTop: "-8px" }}
            >
              {processpayable == true ? (
                <FormControlLabel
                  value="yes"
                  onClick={() => setprocesspayable(true)}
                  control={<Radio />}
                  label="yes"
                  checked
                />
              ) : (
                <FormControlLabel
                  value="yes"
                  onClick={() => setprocesspayable(true)}
                  control={<Radio />}
                  label="yes"
                />
              )}

              {processpayable == false ? (
                <FormControlLabel
                  value="no"
                  onClick={() => setprocesspayable(false)}
                  control={<Radio />}
                  checked
                  label="No"
                />
              ) : (
                <FormControlLabel
                  value="no"
                  onClick={() => setprocesspayable(false)}
                  control={<Radio />}
                  label="No"
                />
              )}
            </RadioGroup>
          </FormControl>
        </MDBox>
      </Grid>
      {processpayable == true ? (
        <Grid item md={12}>
          <MDTypography mb={1} variant="button" display="block" gutterBottom>
            How much is the {props.type}?
          </MDTypography>
          <MDBox mb={1}>
            <input
              defaultValue={props.edit_data}
              type="number"
              name={props.name}
              className="form-control"
              step="0.01"
              style={{
                width: "97%",
                height: "40px",
              }}
            />
          </MDBox>
        </Grid>
      ) : (
        <input type="hidden" name={props.name} />
      )}
    </>
  );
};

export default Payable;
